import styled from 'styled-components';

export const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  gap: 8px;
  .ant-col:has(&) {
    order: -1 !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  .icon-question {
    font-size: 24px;
    color: #656565;
  }

  .label-text {
    font-size: 16px;
    color: #262626;
    margin: 0;
  }

  .ant-switch {
    min-width: 44px;
  }
`;
